import React, { useEffect } from 'react';

interface Props {
  /** 图形验证码图片 base64 */
  captchaImg?: string;
  /** 已输入的图形验证码 */
  captchaCode: string;
  /** 输入变化 */
  onChange: (v: string) => void;
  /** 点击刷新图形验证码图片 */
  onRefresh: () => void;
  /** 点确定：把图形验证码提交后端，校验通过才下发短信 */
  onConfirm: () => void;
  /** 关闭弹窗（取消 / 点遮罩 / 关闭图标）：不下发短信 */
  onClose: () => void;
}

/**
 * 返费页图形验证码弹窗
 * <p>点击「获取验证码」后弹出，图形验证码校验通过后才真正下发短信验证码</p>
 */
export default function CaptchaDialog({ captchaImg, captchaCode, onChange, onRefresh, onConfirm, onClose }: Props) {
  useEffect(() => {
    window.document.body.style.overflow = 'hidden';
    return () => {
      window.document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="captcha-dialog">
      <div className="captcha-mask" onClick={onClose} />
      <div className="captcha-center">
        <div className="captcha-title-block">
          <div className="captcha-title">请输入图形验证码</div>
          <div className="captcha-close" onClick={onClose}>
            <img alt="" className="close-icon" src="/pic/icon_close_dialog.png" />
          </div>
        </div>
        <div className="captcha-body">
          <div className="captcha-input-row">
            <input
              className="input w-160 font-size-16 border-none bg-555"
              type="text"
              maxLength={4}
              placeholder="请输入图形验证码"
              value={captchaCode}
              onChange={(v) => onChange(v?.target?.value || '')}
            />
            <img
              src={`data:image/png;base64,${captchaImg}`}
              alt=""
              className="captcha-img"
              title="点击刷新验证码"
              onClick={onRefresh}
            />
          </div>
          <div className="captcha-btn-row">
            <div className="captcha-btn cancel" onClick={onClose}>取消</div>
            <div className="captcha-btn confirm" onClick={onConfirm}>确定</div>
          </div>
        </div>
      </div>
    </div>
  );
}
